import React, { useState, Component, useEffect } from 'react';
import { connect } from 'react-redux'
import * as actions from '@/models/orders/actions'
import * as services from '@/models/orders/services';
import cn from 'classnames';
import { Modal, Form, Avatar, Button, Select, Input, Popconfirm, message, Icon, Tabs, Table } from 'antd';
import styles from './styles.module.less';


function TeamMember(props) {
  const { children, order, form, onChangeActiveStaff } = props
  const { getFieldDecorator, validateFields, getFieldValue } = form;

  const [showDialog, toggleDialog] = useState(false);
  const [managerList, setManagerList] = useState([]);
  const [activeManager, setActiveManage] = useState(0);
  const [active, setActive] = useState({});

  const managerColumns = [
    {
      title: '群成员',
      dataIndex: 'user',
      key: 'user',
      width: 180,
      render: user => <span className={styles.priceName}>
        <Avatar size="small" src={user?.avatar} style={{ marginRight: '10px' }}></Avatar>
        {user?.name}</span>,
    },
    {
      title: '电话',
      width: 120,
      key: 'userMobile',
      render: item => <span>{item?.user?.mobile}</span>,
    },
    {
      title: '是否在线',
      width: 80,
      key: 'expressNo',
      render: item => <a style={{ color: item?.user?.is_online ? '' : '#999' }}>{item?.user?.is_online ? '在线' : '离线'}</a>
    },
    {
      title: '备注',
      width: 100,
      dataIndex: 'ext',
      key: 'ext',
    },
    {
      title: '选择',
      width: 80,
      key: 'action',
      render: (text, record) => (
        <span>
          {active?.user?._id == record?.user?._id ?
            <div style={{ width: '56px', textAlign: 'center' }}>
              <Icon type="check" style={{ fontSize: '22px', color: '#17A55C' }} />
            </div>
            :
            <a onClick={() => {
              setActive(record)
            }}>点击选择</a>}
        </span>
      ),
    },
  ];

  const initData = () => {
    services.getManagersCustom().then(res => {
      let list = res.data || []
      const aList = list.filter(item => item?.user?.is_online)
      setActiveManage(aList.length)
      setManagerList(res.data || []);
    })
  }
  const close = () => {
    setActive({})
    toggleDialog(false)
  }
  const handleSubmit = () => {
    onChangeActiveStaff(active)
    close()
  }
  useEffect(() => {
    if (showDialog) {
      initData()
    }
  }, [showDialog])

  return (
    <React.Fragment>
      {
        React.isValidElement(children) && React.cloneElement(children, {
          onClick: toggleDialog,
        })
      }
      <Modal
        title={(<>切换员工<span
          style={{ fontSize: '14px', color: '#999', marginLeft: '10px' }}
        >在线/全部：{activeManager}/{managerList.length}</span></>)}
        destroyOnClose

        width={650}
        visible={!!showDialog}
        onOk={() => { handleSubmit() }}
        onCancel={() => close()}
      >
        <Table rowKey="_id" size="middle" bordered={false} columns={managerColumns} dataSource={managerList}
          pagination={false}
          scroll={{ y: '300px' }} />
      </Modal>
    </React.Fragment>
  );
}


export default connect()(Form.create()(TeamMember))